"use strict";

var chipsTagsCtrl = [
    "$http",
    "Member",
    "Department",
    "$scope",
    "$state",
    "toast",
    "$timeout",
    "$translate",
    function ($http, Member, Department, $scope, $state, toast, $timeout, $translate) {
        var _this = this;
        this.list = JSON.parse(JSON.stringify(this.list || [])); // Selected list
        this.filterList = JSON.parse(JSON.stringify(this.filter || [])); // List to select
        this.users = this.users;
        this.list?.sort(function(a, b) {
            return a.name.localeCompare(b.name); // Ordenamos por 'name'
        });
        this.filterList?.sort(function(a, b) {
            return a.name.localeCompare(b.name); // Ordenamos por 'name'
        });

        this.addTagToList = function (item) {
            var tagPromises = _this.users.map(function(user) {
                if (!user?.tags?.some(t => t.id === item.id)) {
                    return Member.tags?.link(
                        { id: user.id }, 
                        { fk: item.id }
                    ).$promise.then(function (data) {
                        if (!user.tags) {
                            user.tags = [];
                        }
                        user.tags.push(item);
                    })
                    .catch(function (error) {
                        toast.error($translate.instant('DASHBOARD.DASH_DEPT.ERROR_TAG_USER_ASSIGN'));
                        console.log(error);
                    });
                }
                return Promise.resolve();
            });
            Promise.all(tagPromises).then(function () {
                _this.list = [..._this.list, item];
                _this.list?.sort(function(a, b) {
                    return a.name.localeCompare(b.name);
                });
                $timeout(() => {
                    _this.newTag = "";
                    _this.getTags();
                    document.querySelector('.chip__input').blur();
                    $timeout(() => {
                        document.querySelector('.chip__input').focus();
                    },50)
                }, 50)
            });
        };        

        this.removeChip = function (index) {
            var tagToRemove = _this.list[index];
            _this.users.forEach(function (user) {
                Member.tags.unlink({
                    id: user.id,
                    fk: _this.list[index].id
                })
                    .$promise.then(function (data) {
                        var removedTag = user.tags.splice(user.tags.findIndex(t => t.id === tagToRemove.id), 1);
                    })
                    .catch(function (error) {
                        toast.error($translate.instant('DASHBOARD.DASH_DEPT.ERROR_TAG_USER_UNLINK'));
                        console.log(error);
                    });
            });
            _this.list.splice(index, 1);
        };
        
        this.getTags = function (query) {
            let availableTags = _this.filterList?.filter(function (tag) {
                    return !_this.list?.some(function (selectedTag) {
                        return selectedTag.id === tag.id;
                    });
                })
                .sort(function(a, b) {
                    return a.name.localeCompare(b.name);
                });
          
            // Filtrar por query ?
            if (query) {
              let lowerCaseQuery = query.toLowerCase();
              
              availableTags = availableTags?.filter(function (tag) {
                    return tag.name.toLowerCase().includes(lowerCaseQuery);
                })
                .sort(function(a, b) {
                    return a.name.localeCompare(b.name);
                });
            }
          
            return availableTags;
        };
    },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      list: "=",
      filter: "=",
      users: "=",
      getFrom: "&",
    },
    controller: chipsTagsCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl: "chips-tags-directive/chipsTagsDirective.html",
    link: function (scope, element, attr) {
      scope.attr = attr;
    },
  };
};
